module.exports = __webpack_public_path__ + "img/qc.e2d04b23.png";